import styled from 'styled-components'


export const SignInContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 480px;
    `
export const H2 = styled.h2`
        margin: 10px 0px;
        `

export const BtnContainer = styled.div`
    display: flex;
    justify-content: space-between;
    `


